import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { Filters } from '@/domain';
import * as resultActions from '@/ducks/results/resultsActions';

export const useFilterResults = (apiExternalUrl: string, useNewDefaultSorting: boolean) => {
    const dispatch = useDispatch();

    return useCallback(
        (filter: Filters) => dispatch(resultActions.filterResults(apiExternalUrl, { ...filter, useNewDefaultSorting })),
        [dispatch, apiExternalUrl, useNewDefaultSorting],
    );
};
